import React from 'react';
import { Box } from 'edenred-ui';
import { useTheme } from 'styled-components';

import { IBenefitTileCommon } from '@epi-models/pages/BenefitGroups';

export const BenefitTileCommon = ({
  icon,
  title,
  limit
}: IBenefitTileCommon) => {
  const { gray50, sizeExtraSmall } = useTheme();

  return (
    <Box display="flex" gap={1} alignItems="center">
      <Box display="inline-block">{icon}</Box>
      <Box>
        <Box fontSize={sizeExtraSmall}>{title}</Box>
        <Box display="flex" gap={0.5} alignItems="center">
          <Box fontSize={sizeExtraSmall}>{limit}</Box>
          <Box color={gray50}> €</Box>
        </Box>
      </Box>
    </Box>
  );
};
